<template>
    <div>
        <h2>This is Menu Footer Section</h2>
    </div>
</template>
  
<script>
  export default {
    name: 'MenuFooter'
  }
</script>
  
<style scoped>
 
</style>